export default __webpack_public_path__ + "static/media/289.6d0ae4b1.jpg";